<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi">To my parents,</p>
<p class="dedi1">Carl and Jean</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Dedication.vue?b0d9f658